import React from 'react';

// Composant dédié à la configuration initiale des joueurs
const PlayerSetup = ({
  players,
  newPlayerName,
  onNameChange,
  onAddPlayer,
  onRemovePlayer,
  onStartGame
}) => (
  <div className="player-section">
    <h2>Configuration des joueurs</h2>
    <div className="score-input">
      <input
        type="text"
        placeholder="Nom du joueur"
        value={newPlayerName}
        onChange={(e) => onNameChange(e.target.value)}
        onKeyPress={(e) => e.key === 'Enter' && onAddPlayer()}
      />
      <button onClick={onAddPlayer} disabled={!newPlayerName.trim()}>
        Ajouter
      </button>
    </div>

    <div className="players-list">
      {players.map((player) => (
        <div key={player.id} className="player-item">
          <span>{player.name}</span>
          <button
            onClick={() => onRemovePlayer(player.id)}
            className="btn-danger"
            style={{ padding: '5px 10px', fontSize: '0.9rem' }}
          >
            Supprimer
          </button>
        </div>
      ))}
    </div>

    <div className="game-controls">
      <button
        onClick={onStartGame}
        className="control-btn btn-primary"
        disabled={players.length < 2}
      >
        Commencer la partie ({players.length} joueurs)
      </button>
    </div>
  </div>
);

export default PlayerSetup;

